module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Link articles":"Link articles","No related articles selected":"No related articles selected"},"de":{"Link articles":"Artikel verknüpfen","No related articles selected":"Keine verknüpften Artikel ausgewählt","Dismiss":"Abbrechen","Ok":"Ok"}}')
  delete Component.options._Ctor
}
